import React, { Fragment } from "react";

import { get } from "lodash"
import { useQuery } from "react-apollo";
import { Segment, Divider } from "semantic-ui-react";

import { INTROSPECTION_QUERY, TYPES_QUERY } from "../../../graphql/introspectionQuery";
import { downTheRabbitHole } from "../../../utils/graphTraversalUtils";

import ObjectContainer from './components/ObjectContainer'
import ReturnType from "./components/ReturnType";

// import fire from "../../../components/App/fire";

const ReferenceObjectContainer = () => {
  let query = [];
  let description = "";
  let parameters = [];
  let returnType = {};
  const paths = window.location.pathname.split('/')
  const accessedField = paths[3]
  const isPathQuery = paths[2] === 'queries'
  const introspectionType = isPathQuery ? 'Query' : 'Mutation'

  // const typesRef = fire
  //   .database()
  //   .ref("types")
  //   .orderByKey();

  const { loading: introspectionLoading, data: introspectionData } = useQuery(INTROSPECTION_QUERY, { variables: { type: introspectionType } });
  const { loading: typesLoading, data: typesData } = useQuery(TYPES_QUERY);

  if (introspectionLoading || typesLoading) return <Segment loading basic />

  const { fields } = introspectionData.__type
  const { types } = typesData.__schema


  if (fields && paths[2] !== 'types') {
    query = fields.find(field => field.name === accessedField);
    description = query.description || 'A graphql object'
    parameters = query.args.map(element => ({
      name: element.name,
      description: element.description,
      type: downTheRabbitHole(element.type),
      isRequired: get(element, "type.kind", '') === 'NON_NULL'
    }));
  }

  if (types) {
    const returnTypeName = downTheRabbitHole(query.type);
    const typeName = returnTypeName || accessedField
    returnType = types.find(type => type.name === typeName);
  }

  return (
    <Segment basic>
      {paths[2] !== 'types' && (
        <Fragment>
          <ObjectContainer
            type={isPathQuery ? 'Queries' : 'Mutations'}
            name={accessedField}
            description={description}
            parameters={parameters}
          />
          {/*  <Header as="h4" color="blue">
          <Link
            to={{
              pathname: "/explorer",
              query: { name, type: type === "Queries" ? "Query" : "Mutation" }
            }}
          >
            Try it here!
            </Link>
        </Header> */}
          <Divider section />
        </Fragment>
      )}

      <ReturnType
        objectType={isPathQuery ? 'query' : 'mutation'}
        type={returnType}
      />
    </Segment>
  )
}

export default ReferenceObjectContainer
